// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - AI Area
export var AIGetRouteQueryTask;
(function (AIGetRouteQueryTask) {
    AIGetRouteQueryTask["amy"] = "amy";
    AIGetRouteQueryTask["agent"] = "agent";
})(AIGetRouteQueryTask || (AIGetRouteQueryTask = {}));
export var AIAgentPersona;
(function (AIAgentPersona) {
    AIAgentPersona["cody"] = "cody";
})(AIAgentPersona || (AIAgentPersona = {}));
export var RelaySummarizeStrategy;
(function (RelaySummarizeStrategy) {
    RelaySummarizeStrategy["noun"] = "noun";
    RelaySummarizeStrategy["verb"] = "verb";
})(RelaySummarizeStrategy || (RelaySummarizeStrategy = {}));
export class AreaRelay {
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(dataCore) {
        this.dataCore = dataCore;
    }
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - AI features
    /** Answer questions and/or chat about product-development topics with full knowledge of your product development data.
     * @param from - Version identifier
     * @param prompt - Question to answer
     * @param options - Answering options
     * @returns Readable stream of amy's response
     */
    async invokeAmy(prompt, chatId, context, systemPrompt) {
        return this.dataCore.invokeAmy(context.workspaceId, context.designSystemId, context.versionId, prompt, chatId, systemPrompt);
    }
    /** Execute specific agent on top of a already existing project.
     * @param prompt - User instruction that tells agent what to do
     * @param projectId - Project identifier (note the project must be already created)
     * @param branchId - Optional branch identifier (if not provided, the default branch will be used)
     * @returns Readable stream of the agent's response
     */
    async invokeAgent(agent, prompt, projectId, branchId) {
        return this.dataCore.invokeAgent(agent, prompt, projectId, branchId);
    }
    /** Retrieves dynamic URL for all AI tasks. Use the URL to
     * @param task - Which task to retrieve URL for
     * @returns Url for the task
     *
     */
    async executableTaskUrl(task) {
        return this.dataCore.executableTaskUrl(task);
    }
    /** Summarize text into a heavily condensed form.
     * @param text - Text to summarize
     * @param options - Summarization options
     * @returns Object containing the original and summarized text
     */
    async summarizeText(text, options) {
        return this.dataCore.summarizeText(text, options);
    }
}
